import { useState } from 'react';
import GetCustomerProfileService from '../services/GetCustomerProfileService';
import { useSelector, useDispatch } from 'react-redux';
import { getCustomerProfiles as fetchCustomerProfilesThunk, selectCustomerProfiles } from '../redux/features/customerProfileSlice';

const useGetCustomerProfile = (contactName) => {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const shopName = useSelector((state) => state.shop.name);
  const dispatch = useDispatch();
  // Share the Redux customer-list cache instead of each modal fetching the whole table on
  // open (I24). getCustomerProfiles below dispatches the cached thunk.
  const profiles = useSelector(selectCustomerProfiles) || [];

  // applyToState=false: return the data without touching the shared profile state —
  // for callers that must guard against stale async responses themselves (OrderForm:
  // a slow response landing after the admin pasted a new contact / submitted was
  // resurrecting the previous customer's name).
  const getProfileFromContact = async (contact, applyToState = true) => { //Fix Shop
    if (!contact) {
      if (applyToState) setProfile(null);
      setLoading(false);
      return true;
    }
    try {
      const response = await GetCustomerProfileService.getCustomerProfileFromContact({contact,shop:shopName});
      if (applyToState) setProfile(response.data);
      setLoading(false);
      return response.data
    } catch (err) {
      //console.log(err)
      setError(err);
      setLoading(false);
      return false
    }
  };

  const getProfileFromPhone = async (phone) => {
    if (!phone) {
      setProfile(null);
      setLoading(false);
      return true;
    }
    try {
      const updatedFormData = {...{phone}, shop:shopName}
      const response = await GetCustomerProfileService.getProfileFromPhone(updatedFormData);
      console.log(response.data)
      setProfile(response.data);
      setLoading(false);
      return true
    } catch (err) {
      console.log(err)
      setError(err);
      setLoading(false);
      return false
    }
  };

  const getDefaultProfile = async () => {
    try {
      const response = await GetCustomerProfileService.getDefaultProfile(shopName);
      setProfile(response.data);
      setLoading(false);
      return response.data
    } catch (err) {
      setError(err);
      setLoading(false);
      console.log(err.response.data.message)
      return false
    }
  };

  const getCustomerProfiles = async () => {
    try {
      // Cached per shop for the session (see the slice's condition). On a cache hit RTK
      // skips the request and returns no payload — fall back to the list already in the store.
      const action = await dispatch(fetchCustomerProfilesThunk(shopName));
      setLoading(false);
      return action.payload ?? profiles
    } catch (err) {
      setError(err);
      setLoading(false);
      return false
    }
  };

  const editDefaultProfile = async (updatedProfile) => {
    try {
      const shopAddedProfile = {...updatedProfile, shop:shopName}
      await GetCustomerProfileService.updateDefaultProfile(shopAddedProfile);
      setLoading(false);
      return true
    } catch (err) {
      setError(err);
      setLoading(false);
      return false
    }
  };

  const getDefaultRateAdjustments = async () => {
    try {
      const response = await GetCustomerProfileService.getDefaultRateAdjustments(shopName);
      return response.data.data;
    } catch (err) {
      setError(err);
      return [];
    }
  };

  const updateDefaultRateAdjustments = async (rateAdjustments) => {
    try {
      await GetCustomerProfileService.updateDefaultRateAdjustments(shopName, rateAdjustments);
      return true;
    } catch (err) {
      setError(err);
      return false;
    }
  };

  return { profile, profiles, loading, error, setProfile, getProfileFromContact, getDefaultProfile, editDefaultProfile, getCustomerProfiles, getProfileFromPhone, getDefaultRateAdjustments, updateDefaultRateAdjustments };
}

export default useGetCustomerProfile;
